// Player measurement formatting.
//
// Date and time formatting lives in ./dateTime — do not add it here.

// Weight formatting
export const formatWeight = (weight: number): string => {
  return `${weight} lbs`;
};

// Height formatting (assuming height is stored as string like "6'2\"")
export const formatHeight = (height: string): string => {
  return height;
};

/**
 * Returns the sport-specific speed/agility measurement label.
 * @param sport   The team's sport.
 * @param includeUnit  When true, appends "(s)" so the label works as a form field label.
 */
export const getSpeedLabel = (sport: string | undefined, includeUnit = false): string => {
  let label: string;
  switch (sport) {
    case 'Football':
    case 'FlagFootball':
    case 'Lacrosse':
      label = '40 Time';
      break;
    case 'Baseball':
    case 'Softball':
      label = 'Home to 1st';
      break;
    case 'Basketball':
      label = '3/4 Court Sprint';
      break;
    case 'Hockey':
      label = '30m Sprint';
      break;
    case 'Soccer':
      label = '40m Sprint';
      break;
    case 'Volleyball':
      label = '20m Sprint';
      break;
    case 'Tennis':
      label = 'Baseline-to-Net Sprint';
      break;
    default:
      label = '40 Time';
  }
  return includeUnit ? `${label} (s)` : label;
};
